module.exports = __webpack_public_path__ + "static/media/janssen.c4ed5ff4.png";